import React from 'react';
import AppHeader from '../components/layout/AppHeader';

const TermsOfService: React.FC = () => {
    return (
        <div className="min-h-screen bg-premium-wood-dark text-white font-sans">
            <AppHeader title="Terms of Service" />
            <main className="container mx-auto px-4 py-12 max-w-4xl">
                <h1 className="text-4xl font-serif font-bold text-premium-gold mb-8">Terms of Service</h1>
                <div className="prose prose-invert prose-gold max-w-none text-white/80">
                    <p className="lead text-xl">Welcome to TechUnity Global. By accessing or using our platform, you agree to be bound by these Terms of Service.</p>

                    <h3 className="text-white mt-8 mb-4 text-xl font-bold">1. Acceptance of Terms</h3>
                    <p>By accessing or using our services, you agree to be bound by these terms. If you do not agree to these terms, you may not access or use usage of our services.</p>

                    <h3 className="text-white mt-8 mb-4 text-xl font-bold">2. User Accounts</h3>
                    <p>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>

                    <h3 className="text-white mt-8 mb-4 text-xl font-bold">3. User Conduct</h3>
                    <p>You agree not to engage in any activity that interferes with or disrupts the services or servers or networks connected to the services.</p>

                    <h3 className="text-white mt-8 mb-4 text-xl font-bold">4. Termination</h3>
                    <p>We reserve the right to terminate or suspend access to our service immediately, without prior notice or liability, for any reason whatsoever.</p>

                    <h3 className="text-white mt-8 mb-4 text-xl font-bold">5. Contact</h3>
                    <p>Questions about the Terms of Service should be sent to us at <a href="mailto:support@techunityglobal.com" className="text-premium-gold hover:underline">support@techunityglobal.com</a>.</p>
                </div>
            </main>
        </div>
    );
};

export default TermsOfService;
